export default {"src":"/_next/static/media/star-gold.1153e3f1.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};